export default __webpack_public_path__ + "static/media/045-no-fire.69623441.png";